export default "__VITE_ASSET__BzG0h2DS__"